import * as Implementation from "./Implementation/index.js";
/** CoStar.Api.MyData.EntityType */
export var EntityType;
(function (EntityType) {
    EntityType[EntityType["None"] = 0] = "None";
    EntityType[EntityType["Property"] = 1] = "Property";
    EntityType[EntityType["Tenant"] = 2] = "Tenant";
    EntityType[EntityType["LeaseDeal"] = 3] = "LeaseDeal";
})(EntityType || (EntityType = {}));
/** CoStar.Api.MyData.UserDefinedFieldType */
export var UserDefinedFieldType;
(function (UserDefinedFieldType) {
    UserDefinedFieldType[UserDefinedFieldType["None"] = 0] = "None";
    UserDefinedFieldType[UserDefinedFieldType["Character"] = 1] = "Character";
    UserDefinedFieldType[UserDefinedFieldType["Numeric"] = 2] = "Numeric";
    UserDefinedFieldType[UserDefinedFieldType["Date"] = 3] = "Date";
    UserDefinedFieldType[UserDefinedFieldType["Logical"] = 4] = "Logical";
    UserDefinedFieldType[UserDefinedFieldType["Notes"] = 5] = "Notes";
})(UserDefinedFieldType || (UserDefinedFieldType = {}));
/** CoStar.Api.MyData.ListMatchType */
export var ListMatchType;
(function (ListMatchType) {
    ListMatchType[ListMatchType["None"] = 0] = "None";
    ListMatchType[ListMatchType["MatchAny"] = 1] = "MatchAny";
    ListMatchType[ListMatchType["MatchAll"] = 2] = "MatchAll";
})(ListMatchType || (ListMatchType = {}));
export { Implementation };
